import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {BlogService} from '@core/ecv-http-services/services/blog.service';
import {CertificateService} from '@core/ecv-http-services/services/certificate.service';
import {ConferenceService} from '@core/ecv-http-services/services/conference.service';
import {PublicationService} from '@core/ecv-http-services/services/publication.service';
import {RepositoryService} from '@core/ecv-http-services/services/repository.service';
import {SocialMediaService} from '@core/ecv-http-services/services/social-media.service';
import {TrainingService} from '@core/ecv-http-services/services/training.service';
import {GithubConnectorService} from '@core/ecv-http-services/services/github-connector.service';
import {StepComponentAbstract} from '../flow/step.component';
import {ValidatorService} from '@core/validator/validator.service';
import {BlogModel} from './blog.model';
import {CertificateModel} from './certificate.model';
import {ConferenceModel} from './conference.model';
import {PublicationModel} from './publication.model';
import {Repository} from './repository.enum';
import {RepositoryModel} from './repository.model';
import {SocialMedia} from './social-media.enum';
import {SocialMediaModel} from './social-media.model';
import {TrainingModel} from './training.model';
import {DictEnum} from '../enums/dict.enum';
import {Observable} from 'rxjs/Observable';
import {DialogService} from '../dialog/dialog.service';
import DateUtils from '../shared/date-utils';
import {NgRedux} from 'ng2-redux';
import {IAppState} from '../store';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';


@Component({
  selector: 'app-network',
  templateUrl: './network.component.html'
})
export class NetworkComponent extends StepComponentAbstract implements OnInit {

  @Input() data: any;

  DictEnum = DictEnum;
  socialMedia: SocialMediaModel[];
  repositories: RepositoryModel[];
  blogs: BlogModel[];
  certificates: CertificateModel[];
  conferences: ConferenceModel[];
  publications: PublicationModel[];
  trainings: TrainingModel[];

  userId: number;

  serviceInitialId = 0;

  constructor(private validatorService: ValidatorService,
              private socialMediaService: SocialMediaService,
              private repositoryService: RepositoryService,
              private blogService: BlogService,
              private certificateService: CertificateService,
              private conferenceService: ConferenceService,
              private publicationService: PublicationService,
              private githubService: GithubConnectorService,
              private dialogService: DialogService,
              private trainingService: TrainingService,
              private ngRedux: NgRedux<IAppState>,
              private spinnerService: Ng4LoadingSpinnerService) {
    super();
    this.socialMedia = [];
    this.repositories = [];
    this.blogs = [];
    this.certificates = [];
    this.conferences = [];
    this.publications = [];
    this.trainings = [];
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.stepForm = new FormGroup({});
  }

  loadData(userId): void {
    this.userId = userId;

    this.conferenceService.getAllConferences(userId).subscribe(
      (response) => {
        this.conferences = response;
      });

    this.publicationService.getAllPublications(userId).subscribe(
      (response) => {
        this.publications = response;
      });

    this.socialMediaService.getAllSocialMedia(userId).subscribe(
      (response) => {
        this.socialMedia = response;
      });

    this.repositoryService.getAllRepositories(userId).subscribe(
      (response) => {
        this.repositories = response;
      });

    this.certificateService.getAllCertificates(userId).subscribe(
      (response) => {
        this.certificates = response;
      });

    this.trainingService.getAllTrainings(userId).subscribe(
      (response) => {
        this.trainings = response;
      });

    this.blogService.getAllBlogs(userId).subscribe(
      (response) => {
        this.blogs = response;
      });
  }

  getRepositoryEnum() {
    return Repository;
  }

  getSocialMediaEnum() {
    return SocialMedia;
  }

  isUserDataNumberType(serviceNumber: number) {
    return serviceNumber === 2;
  }

  onSave(): Observable<any> {
    if (this.isSaveInProgress) {
      return Observable.of(true);
    }
    for (let i = 0; i < this.socialMedia.length; i++) {
      this.socialMedia[i].url = this.socialMedia[i].url ? this.socialMedia[i].url.trim() : null;
      this.socialMedia[i].userName = this.socialMedia[i].userName ? this.socialMedia[i].userName.trim() : null;
    }
    for (let i = 0; i < this.repositories.length; i++) {
      this.repositories[i].url = this.repositories[i].url ? this.repositories[i].url.trim() : null;
      this.repositories[i].userName = this.repositories[i].userName ? this.repositories[i].userName.trim() : null;
    }
    for (let i = 0; i < this.blogs.length; i++) {
      this.blogs[i].url = this.blogs[i].url ? this.blogs[i].url.trim() : null;
    }
    for (let i = 0; i < this.certificates.length; i++) {
      this.certificates[i].dateFrom.dateFormat = DateUtils.parseDateFormat(this.certificates[i].dateFrom.date);
      this.certificates[i].dateTo.dateFormat = DateUtils.parseDateFormat(this.certificates[i].dateTo.date);
    }
    for (let i = 0; i < this.conferences.length; i++) {
      this.conferences[i].description = this.conferences[i].description ? this.conferences[i].description.trim() : null;
      this.conferences[i].name = this.conferences[i].name ? this.conferences[i].name.trim() : null;
      this.conferences[i].startDate.dateFormat = DateUtils.parseDateFormat(this.conferences[i].startDate.date);
      this.conferences[i].endDate.dateFormat = DateUtils.parseDateFormat(this.conferences[i].endDate.date);
    }
    for (let i = 0; i < this.publications.length; i++) {
      this.publications[i].description = this.publications[i].description ? this.publications[i].description.trim() : null;
      this.publications[i].name = this.publications[i].name ? this.publications[i].name.trim() : null;
      this.publications[i].publicationDate.dateFormat = DateUtils.parseDateFormat(this.publications[i].publicationDate.date);
    }
    for (let i = 0; i < this.trainings.length; i++) {
      this.trainings[i].description = this.trainings[i].description ? this.trainings[i].description.trim() : null;
      this.trainings[i].trainingDate.dateFormat = DateUtils.parseDateFormat(this.trainings[i].trainingDate.date);
    }
    this.validatorService.validate(this.stepForm);
    if (!this.validatorService.isValid(this.stepForm)) {
      return Observable.of(false);
    }

    let changes: Observable<any>[] = this.updateChanges();
    if (changes.length === 0) {
      return Observable.of(true);
    } else {
      this.isSaveInProgress = true;
      return Observable.forkJoin(changes)
        .map(() => {
          this.isSaveInProgress = false;
        }, () => {
          this.isSaveInProgress = false;
        });
    }

  }

  updateChanges(): Observable<any>[] {
    return [
      ...this.saveSocialMedia(),
      ...this.saveRepositories(),
      ...this.saveBlogs(),
      ...this.saveCertificates(),
      ...this.saveConferences(),
      ...this.savePublications(),
      ...this.saveTrainings()
    ];
  }

  addSocialMedia() {
    const newSocialMediaItem: SocialMediaModel = new SocialMediaModel();
    newSocialMediaItem.userId = this.userId;
    newSocialMediaItem.service = this.serviceInitialId;
    this.socialMedia.push(newSocialMediaItem);
  }

  removeSocialMedia(index: number) {
    this.socialMedia[index].deleted = true;
  }

  addRepository() {
    const newRepository: RepositoryModel = new RepositoryModel();
    newRepository.userId = this.userId;
    newRepository.service = this.serviceInitialId;
    this.repositories.push(newRepository);
  }

  removeRepository(index: number) {
    this.repositories[index].deleted = true;
  }

  addBlog() {
    const newBlog: BlogModel = new BlogModel();
    newBlog.userId = this.userId;
    this.blogs.push(newBlog);
  }

  removeBlog(index: number) {
    this.blogs[index].deleted = true;
  }

  addCertificate() {
    const newCertificate: CertificateModel = new CertificateModel();
    newCertificate.userId = this.userId;
    this.certificates.push(newCertificate);
  }

  removeCertificate(index: number) {
    this.certificates[index].deleted = true;
  }

  addConference() {
    const newConference: ConferenceModel = new ConferenceModel();
    newConference.userId = this.userId;
    this.conferences.push(newConference);
  }

  removeConference(index: number) {
    this.conferences[index].deleted = true;
  }

  addPublication() {
    const newPublication: PublicationModel = new PublicationModel();
    newPublication.userId = this.userId;
    this.publications.push(newPublication);
  }

  removePublication(index: number) {
    this.publications[index].deleted = true;
  }

  addTraining() {
    const newTraining: TrainingModel = new TrainingModel();
    newTraining.userId = this.userId;
    this.trainings.push(newTraining);
  }

  removeTraining(index: number) {
    this.trainings[index].deleted = true;
  }

  searchGithub() {
    this.spinnerService.show();
    this.githubService.searchProfile(this.userId).subscribe(
      response => {
        this.spinnerService.hide();
        this.dialogService.openGithubProfilesModal(response, this);
      }, error => {
        this.spinnerService.hide();
      });
  }

  searchGoogleScholarPublications() {
    const refNumber = this.ngRedux.getState().searchedRefNumber;
    this.publicationService.searchGoogleScholarPublications(refNumber).subscribe(response => {
      this.dialogService.openGoogleScholarPublicationsModal(response, this);
    });
  }

  private saveSocialMedia(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const socialMediaItemToRemove of this.socialMedia) {
      if (socialMediaItemToRemove.id && socialMediaItemToRemove.deleted) {
        changes.push(this.socialMediaService.deleteSocialMedia(socialMediaItemToRemove));
      } else if (socialMediaItemToRemove.deleted) {
        continue;
      } else if (socialMediaItemToRemove.id) {
        changes.push(this.socialMediaService.updateSocialMedia(socialMediaItemToRemove));
      } else {
        changes.push(this.socialMediaService.createSocialMedia(socialMediaItemToRemove));
      }
    }
    return changes;
  }

  private saveRepositories(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const repository of this.repositories) {
      if (repository.id && repository.deleted) {
        changes.push(this.repositoryService.deleteRepository(repository));
      } else if (repository.deleted) {
        continue;
      } else if (repository.id) {
        changes.push(this.repositoryService.updateRepository(repository));
      } else {
        changes.push(this.repositoryService.createRepository(repository));
      }
    }
    return changes;
  }

  private saveBlogs(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const blog of this.blogs) {
      if (blog.id && blog.deleted) {
        changes.push(this.blogService.deleteBlog(blog));
      } else if (blog.deleted) {
        continue;
      } else if (blog.id) {
        changes.push(this.blogService.updateBlog(blog));
      } else {
        changes.push(this.blogService.createBlog(blog));
      }
    }
    return changes;
  }

  private saveCertificates(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const certificate of this.certificates) {
      if (certificate.id && certificate.deleted) {
        changes.push(this.certificateService.deleteCertificate(certificate));
      } else if (certificate.deleted) {
        continue;
      } else if (certificate.id) {
        changes.push(this.certificateService.updateCertificate(certificate));
      } else {
        changes.push(this.certificateService.createCertificate(certificate));
      }
    }
    return changes;
  }

  private saveConferences(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const conference of this.conferences) {
      if (conference.id && conference.deleted) {
        changes.push(this.conferenceService.deleteConference(conference));
      } else if (conference.deleted) {
        continue;
      } else if (conference.id) {
        changes.push(this.conferenceService.updateConference(conference));
      } else {
        changes.push(this.conferenceService.createConference(conference));
      }
    }
    return changes;
  }

  private savePublications(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const publication of this.publications) {
      if (publication.id && publication.deleted) {
        changes.push(this.publicationService.deletePublication(publication));
      } else if (publication.deleted) {
        continue;
      } else if (publication.id) {
        changes.push(this.publicationService.updatePublication(publication));
      } else {
        changes.push(this.publicationService.createPublication(publication));
      }
    }
    return changes;
  }

  private saveTrainings(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const training of this.trainings) {
      if (training.id && training.deleted) {
        changes.push(this.trainingService.deleteTraining(training));
      } else if (training.deleted) {
        continue;
      } else if (training.id) {
        changes.push(this.trainingService.updateTraining(training));
      } else {
        changes.push(this.trainingService.createTraining(training));
      }
    }
    return changes;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/network.component.ts